import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getAdminFin } from "http/UAM/userDashboardWidget.helper";
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";

const Top5Fin = () => {
  const [financiersData, setFinanciersData] = useState([]);
  const [showStatus, setShowStatus] = useState(true)

  useEffect(() => {
    getAdminFin().then((res) => {
      if (res.status) {
        setFinanciersData(res.data);
        setShowStatus(true)
      } else {
        setShowStatus(false)
        setFinanciersData([]);
      }
    });
  }, [])

  const xAxisData = financiersData?.map((financier) => financier.financier.entityName);
  while(xAxisData.length<6)
    {
      xAxisData.push(" ")
    }
  const options = {
    chart: {
      type: "bar",
      height: 500,
      background: "transparent",
    },
    plotOptions: {
      bar: {
        horizontal: true,
        endingShape: "flat",
        columnWidth: "50%",
        barHeight: '50%',
        borderRadius: 0,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        switch (dataPointIndex) {
          case 0:
            return "rgb(52, 195, 143)";
          case 1:
            return "rgb(85, 110, 230)";
          case 2:
            return "rgb(244, 106, 106)";
          case 3:
            return "#f1b44c";
          case 4:
            return "#50a5f1";
          default:
            return "#0174BE";
        }
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Deals",
      },
      categories: xAxisData
    },
    yaxis: {},
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val, { seriesIndex, dataPointIndex, w }) {
          return financiersData[dataPointIndex].financier.entityName + ": " + val + " deals";
        },
      },
      fixed: {
        position: "right",
      },
      x: {
        show: false,
      },
    },
    toolbar: {
      show: false
    }
  };

  return (
    <Card>
      {showStatus ? <CardBody>
        <h4 className="card-title mb-2">
          {`Top Financers (Interest Shown)`}
        </h4>
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }} className="mb-2">
        </div>
        <div style={{ maxWidth: "100%" }}>
          <ReactApexChart
            options={options}
            series={[{ name: "", data: financiersData?.map((financier) => financier.dealCount) }]}
            type="bar"
            height={305}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No Financier has Shown Interest" />}
    </Card>
  );
};

export default Top5Fin;
